"use client";
import { useFormatter, useTranslations } from "next-intl";
import { useModal } from "@/components/modal-context";
import { useEffect, useState, useTransition } from "react";
import { ClaimOTB, GetOTB } from "@/lib/actions";
import { Button } from "@/components/custom";
import { toast } from "react-toastify";
import { useRouter } from "@/i18n/routing";

const OTBModal = () => {
  const t = useTranslations();
  const { closeModal } = useModal();
  const [pending, startTransition] = useTransition();
  const [claimableAmount, setClaimableAmount] = useState(0);
  const format = useFormatter();
  const router = useRouter();
  useEffect(() => {
    startTransition(async () => {
      const res = await GetOTB();
      setClaimableAmount(res.data.current_balance);
    });
  }, []);

  const ClaimHandler = () => {
    startTransition(async () => {
      const res = await ClaimOTB();
      if (res.status_code != 0) {
        console.log(res);
        // toast.error(t("otb-claim-fail"));
        toast.error(res.message);
        return;
      }
      toast.success(t("otb-claimed", { amount: res.amount }));
      closeModal();
    });
  };

  return (
    <form action={ClaimHandler} className="flex flex-col items-center justify-center space-y-4 p-4">
      <>
        <div className="text-xl font-bold">One time bonus</div>
        {/* <div className="text-lg">{angpow?.title}</div> */}
        {/* <Image src={angpow?.image_url!} alt="Angpao" width={200} height={200} /> */}
        {/* <div className="text-lg">{angpow?.message}</div> */}
        <div className="bg-gradient-to-r from-[#FFEA92] via-[#C9A04C] to-[#FFFFA5] bg-clip-text text-center text-[32px] font-black leading-none text-transparent drop-shadow-lg">
          {format.number(claimableAmount, {
            style: "currency",
            // notation: "compact",
            currency: "BDT",
            currencyDisplay: "symbol",
            currencySign: "standard",
          })}
        </div>
        <Button type="submit" className="w-32" isDisabled={pending}>
          {t("claim")}
        </Button>
      </>
    </form>
  );
};

export default OTBModal;
